import { axiosInstance } from "../axiosConfig.ts";
import { IOperationResponse, IOperationQueryParams } from "./types.ts";

const basePath = "/v1/operations";

export const operationsAPI = {
  getAllOperations: async (params: IOperationQueryParams = {}): Promise<IOperationResponse> => {
    const { page = 0, size = 20, sort = "date,desc", type = ["TRANCHE"] } = params;

    const response = await axiosInstance.get<IOperationResponse>(basePath, {
      params: {
        page,
        size,
        sort,
        type,
      },
      paramsSerializer: (params) => {
        const searchParams = new URLSearchParams();

        Object.entries(params).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((item) => {
              searchParams.append(key, String(item));
            });
          } else if (value !== undefined) {
            searchParams.append(key, String(value));
          }
        });

        return searchParams.toString();
      },
    });

    return response.data;
  },
};
